import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const { publicPath } = process.env.CONFIG

const router = new Router({
  mode: 'history',
  base: publicPath,
  routes: [
    {
      path: '',
      redirect: '/care'
    },
    {
      path: '/home2',
      component: resolve => require(['../pages/home/Home.vue'], resolve),
      meta: {
        title: '品胜',
        share: 'default'
      }
    },
    {
      path: '/mine',
      component: resolve => require(['../pages/mine/Mine.vue'], resolve),
      meta: {
        title: '个人中心',
        share: 'default'
      }
    },
    {
      path: '/orders',
      component: resolve => require(['../pages/order/OrderCenter.vue'], resolve),
      meta: {
        title: '订单中心',
        share: 'default'
      }
    },
    {
      path: '/preview',
      component: resolve => require(['../pages/preview/Preview.vue'], resolve),
      meta: {
        title: '预览',
        share: 'default'
      }
    },
    {
      path: '/page/:id',
      component: resolve => require(['../pages/page/Page.vue'], resolve)
    },
    {
      path: '/navigation/:id',
      component: resolve => require(['../pages/page/Page.vue'], resolve)
    },
   {
      path: '/home',
      component: resolve => require(['../pages/page/Page.vue'], resolve),
      meta: {
        title: '主页',
        share: 'default'
      }
    },
    // {
    //   path: '/feedback',
    //   component: resolve => require(['../pages/feedback/Feedback.vue'], resolve),
    //   meta: {
    //     title: '意见反馈',
    //     share: 'default'
    //   }
    // },

    {
      path: '/care',
      component: resolve => require(['../pages/my-care/MyCare.vue'], resolve),
      redirect:'/care/list',
      children:[
		  {
		      path: 'anonymous',
		      name: 'anonymous',
		      component: resolve => require(['../pages/my-care/CareListAnonymous.vue'], resolve),
		      meta: {
		          title: '无忧卡'
		      }
		  },
          {
              path: 'list',
              name: 'careList',
              component: resolve => require(['../pages/my-care/CareList.vue'], resolve),
              meta: {
                  title: '我的无忧卡'
              }
          },
          {
              path: 'apply/record',
              name: 'applyRecord',
              component: resolve => require(['../pages/my-care/ApplyRecord.vue'], resolve),
              meta: {
                  title: '申请记录'
              }
          }
      ]
    },{
          path: '/apply/record/:id',
          component: resolve => require(['../pages/my-care/ApplyRecordDetail.vue'], resolve),
          name:"ApplyDetail",
          meta: {
              title: '申请记录详情'
          }
      },{
      path: '/care/card/:code',
      component: resolve => require(['../pages/care-card/CareCard.vue'], resolve),
      name:"CareCard",
      meta: {
        title: '扫码激活'
      }
    },{
          path: '/care/add',
          component: resolve => require(['../pages/care-card/Bind.vue'], resolve),
          name:"BindCareCard",
          meta: {
              title: '添加无忧卡'
          }
      },{
          path: '/care/about',
          component: resolve => require(['../pages/my-care/AboutCard.vue'], resolve),
          name:"AboutCareCard",
          meta: {
              title: '关于无忧卡'
          }
      },{
      path: '/care/active/:code',
      component: resolve => require(['../pages/care-active/CareActive.vue'], resolve),
      name:"CareActive",
      meta: {
        title: '激活卡片'
      }
    },{
      path: '/care/active/:code/complement',
      component: resolve => require(['../pages/care-active/ActiveStepsManager.vue'], resolve),
      name:"ActiveStepsManager",
      meta: {
        title: '激活卡片'
      }
    },
    {
      path: '/care/active/:id/',
      component: resolve => require(['../pages/care-active/ActiveSubmitSuccess.vue'], resolve),
      meta: {
        title: '提交成功'
      }
    },
    {
      path: '/care/:id/service/record',
      component: resolve => require(['../pages/care-record/CareRecord.vue'], resolve),
      name:'CareRecord',
      meta: {
        title: '服务记录'
      }
    },
    {
      path: '/care/:id/orders',
      component: resolve => require(['../pages/care-order/OrderList.vue'], resolve),
      name: 'OrderRecord',
      meta: {
        title: '服务订单'
      }
    },
      {
          path: '/care/order/detail/:id',
          component: resolve => require(['../pages/care-order/Detail.vue'], resolve),
          name: 'CardOrderDetail',
          meta: {
              title: '订单详情'
          }
      },
      {
          path: '/care/order/express/:id',
          component: resolve => require(['../pages/care-order/WriteExpress.vue'], resolve),
          name: 'WriteExpress',
          meta: {
              title: '快递信息'
          }
      },
    {
      path: '/care/:id/service/code',
      component: resolve => require(['../pages/care-service/ServiceCode.vue'], resolve),
      name:'ServiceCode',
      meta: {
        title: '申请服务'
      }
    },
    {
      path: '/care/:id/service/none',
      component: resolve => require(['../pages/care-service/NoService.vue'], resolve),
      name:'NoService',
      meta: {
        title: '申请服务'
      }
    },
    {
      path: '/care/:id/service/form',
      component: resolve => require(['../pages/care-service/ServiceForm.vue'], resolve),
      name:'ServiceForm',
      meta: {
        title: '申请服务'
      }
    },{
      path: '/care/:id/service/form/success',
      component: resolve => require(['../pages/care-service/ApplyServiceSuccess.vue'], resolve),
      name:'ApplyServiceSuccess',
      meta: {
        title: '申请服务'
      }
    },
    {
      path: '/care/:id/service/choose-type',
      component: resolve => require(['../pages/care-service/ChooseServiceType.vue'], resolve),
      name:'ChooseServiceType',
      meta: {
        title: '申请服务'
      }
    },{
      path: '/care/:id',
      component: resolve => require(['../pages/care-detail/CareDetail.vue'], resolve),
      meta: {
        title: '无忧卡'
      }
    },
    {
      path:'/agreement',
      component: resolve => require(['../pages/agreement/index.vue'], resolve),
    },
    {
      path:'/checksn',
      component: resolve => require(['../pages/check-sn/index.vue'], resolve),
    },
    {
      path: '/auth',
      component: resolve => require(['../pages/auth/Authorization.vue'], resolve),
    },
     {
      path: '/login-fail',
      component: resolve => require(['../pages/login-fail/LoginFail.vue'], resolve),
    },
    {
      path: '/goto',
      component: resolve => require(['../components/ShowInWebview.vue'], resolve),
    },
    {
      path: '/test',
      component: resolve => require(['../pages/test/Test.vue'], resolve),
    },
      {
          name: 'CareRenewPay',
          path: '/care/:id/renew',
          component: resolve => require(['../pages/care-card/Renew.vue'], resolve),
          meta: {
              title: '无忧卡续费'
          }
      },
      {
          name:'RenewPaySuccess',
          path: '/care/:id/renew/pay-result',
          component: resolve => require(['../pages/care-card/PaySuccess.vue'], resolve),
          meta: {
              title: '支付结果'
          }
      },{
          path: '/care/renew/:id',
          component: resolve => require(['../pages/care-detail/CareRenewDetail.vue'], resolve),
          meta: {
              title: '无忧卡'
          }
      },
      {
          path: '/sysAgreement',
          component: resolve => require(['../pages/auth/Agreement.vue'], resolve)
      },{
          path: '/care/setting/index',
          component: resolve => require(['../pages/care-setting/Index.vue'], resolve),
          meta: {
              title: '设置'
          }
      },{
          path: '/care/setting/accountcancellation',
          component: resolve => require(['../pages/care-setting/AccountCancellation.vue'], resolve),
          meta: {
              title: '注销账号'
          }
      }
  ]
})

router.intercepts = []
router.addIntercept = function (intercept) {
  this.intercepts.push(intercept)
}

router.beforeEach(async (to, from, next) => {
  for (let i = 0; i < router.intercepts.length; i++) {
    let result = await router.intercepts[i](to, from, next)
    if (result) return
  }
  next()
})


export default router